/* eslint-env browser */
import { useState } from 'react';

const useAUPassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  return [{
    currentPassword,
    setCurrentPassword,
  }, {
    newPassword,
    setNewPassword,
  }, {
    confirmPassword,
    setConfirmPassword,
  }];
};

const useAUPasswordValidation = () => {
  const [currentPasswordValidationMessages, setCurrentPasswordValidationMessages] = useState([]);
  const [newPasswordValidated, setNewPasswordValidated] = useState(false);
  const [newPasswordValidationMessages, setNewPasswordValidationMessages] = useState([]);
  const [confirmPasswordValidated, setConfirmPasswordValidated] = useState(false);
  const [confirmPasswordValidationMessages, setConfirmPasswordValidationMessages] = useState([]);

  return [{
    currentPasswordValidationMessages,
    setCurrentPasswordValidationMessages,
  }, {
    newPasswordValidated,
    setNewPasswordValidated,
    newPasswordValidationMessages,
    setNewPasswordValidationMessages,
  }, {
    confirmPasswordValidated,
    setConfirmPasswordValidated,
    confirmPasswordValidationMessages,
    setConfirmPasswordValidationMessages,
  }];
};

export {
  useAUPassword,
  useAUPasswordValidation,
};
